import React from "react";
import styles from "./QualityControl.module.scss";

import { messages } from "../Delivery.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";

export const QualityControl: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <div className={styles.container}>
      <div key={1} className={styles.carouselItem}>
        <h3 className={styles.title}>{formatMessage(messages.qualityControlTitle)}</h3>
        <ui.Scrollbars>
          <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.qualityControlDescription1) }}></p>
        </ui.Scrollbars>
      </div>
    </div>
  );
};
